<template>
  <section class="section">
    <div class="container" style="margin-top: -30px;">
      <div class="columns" >
        <div class="column">
          <span class="title24"> ຈັບຄູ່ທຸລະກິດ</span>
        </div>
          
      </div>
      <b-tabs v-model="activeTab" >  
        <b-tab-item label="ກຸ່ມທຸລະກິດ">
         
   
          <div class="columns is-mobile card-container" style=" margin: 0px -10px 0px -10px;">
            <!-- First Item -->
            <div class="column is-half card-item" @click="selectBusinessType(1, bussinessgroup1)">
              <div class="card">
                <div class="card-content">
                  ຜູ້ຜະລິດ<br>
                  <span class="red16bold" >{{ bussinessgroup1.length }}</span>
                </div>
              </div>
            </div>
            <!-- Second Item -->
            <div class="column is-half card-item" @click="selectBusinessType(2, bussinessgroup2)"> 
              <div class="card">
                <div class="card-content">
                  ຜູ້ຊື້<br>
                  <span class="red16bold" >{{ bussinessgroup2.length }}</span>
                </div>
              </div>
            </div>
            <!-- Third Item -->
            <div class="column is-half card-item" @click="selectBusinessType(3, bussinessgroup3)">
              <div class="card">
                <div class="card-content">
                  ຜູ້ສະໜອງ<br>
                  <span class="red16bold" >{{ bussinessgroup3.length }}</span>
                </div>
              </div>
            </div>
            <!-- Fourth Item -->
            <div class="column is-half card-item" @click="selectBusinessType(4, bussinessgroup4)">
              <div class="card">
                <div class="card-content">
                  ສະຖາບັນການເງິນ<br>
                  <span class="red16bold" >{{ bussinessgroup4.length }}</span>
                </div>
              </div>
            </div>
          </div>


          

        </b-tab-item>
        <b-tab-item label="ລາຍການທຸລະກິດ" >
         
         <div class="columns" v-if="filteredParticipateList" style="margin-left: -26px; margin-right: -26px; margin-bottom: -10px;">  
           <div class="column">
             <b-field >
               <b-input
               
                 placeholder="ຄວາມສົນໃຈ"
                 v-model.trim="searchByDescription"
                 type="text"
                 @input="searchData()"     
               >  
               </b-input>
             </b-field>
           </div>
         </div>

        
         <div class="columns card-container" v-for="(data, index) in filteredParticipateList " :key="data.ID" style="margin-left: -20px; margin-right: -20px;">  
           <div class="column card-item" >
            <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
              <div class="card-content2 ">
                <div style="margin-bottom: 5px;">
                  <b-field>ລຳດັບ: {{ index +1}}</b-field>
                </div>
                <div style="margin-bottom: 5px;">
                  <b-field>ຊື່ ແລະ ນາມສະກຸນ: <span class="red16bold">{{ data.FULLNAME}}</span></b-field>
                </div>
                <div style="margin-bottom: 5px;">
                  <b-field>ກຸ່ມທຸລະກິດ: <span class="red16bold">{{ data.BUSINESSGROUP}}</span></b-field>
                </div>
                <div style="margin-bottom: 5px;">
                  <b-field>ເບີໂທ: <span class="red16bold">{{ data.PHONENO}}</span></b-field>  
                </div>
                <div style="margin-bottom: 5px;">
                  <!-- <b-field>ຈຳນວນຜູ້ສົນໃຈ: {{ data.INTERESTEDLIST.length}} ຄົນ</b-field> -->
                </div>
                <div style="margin-bottom: 5px;">
                  <b-field>ລາຍລະອຽດ:</b-field>
                  <b-field style="margin-top: -10px;"><span class="red16bold">{{ data.DESCRIPTION}}</span></b-field>
                </div>

                <div style="margin-top: 50px;">
                  <b-field style="margin-bottom: 0px;">ສຳລັບຜູ້ທີ່ສົນໃຈ:</b-field>
                  <b-field label="ຊື່ ແລະ ນາມສະກຸນ">
                      <b-input
                        v-model.trim="selectedFullName"
                        type="text"
                      >  
                      </b-input>
                      
                  </b-field>
                  <b-field label="ເບີໂທຕິດຕໍ່">
                      <b-input
                        v-model.trim="selectedPhoneNo"
                        type="text"
                      >  
                      </b-input>
                  </b-field>
                  <b-field label="ຂໍ້ມູນເພີ່ມເຕີມ">
                    <b-input maxlength="100" rows="2" v-model.trim="selectedBusinessDescription"  type="textarea" ></b-input>

                  </b-field>
                </div>

                <div style="margin-bottom: 5px;">
                  <b-button 
                      class="btn-group-margin is-fullwidth"
                      type="is-success" 
                      @click="interestedIn(data.ID )"
                      >  <span > ສົນໃຈ</span>
                  </b-button>
                </div>
              </div>
            </div>
           </div>
         </div>
         

       </b-tab-item>
        <b-tab-item label="ຟອມລົງທະບຽນຂໍ້ມູນທຸລະກິດ" style="">
          
          <div class="columns" >
            <div class="column">
              <div class="columns" >
                <div class="column">
                  <b-field label="ຊື່ ແລະ ນາມສະກຸນ">
                    <b-input
                      v-model.trim="selectedFullName"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
              </div>

              <div class="columns" >
                <div class="column">
                  <b-field label="ອາຍຸ">
                    <b-input
                      v-model.trim="selectedAge"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ເພດ">
                      <Multiselect     
                        placeholder="ເພດ"
                        v-model.trim="selectedGender"
                        label="NAME"
                        track-by="ID"
                        :options="genderList"   
                      ></Multiselect>
                    </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="ກຸ່ມທຸລະກິດ">
                    <Multiselect     
                      placeholder="ກຸ່ມທຸລະກິດ"
                      v-model.trim="selectedBusinessGroup"
                      label="NAME"
                      track-by="ID"
                      :options="businessGroupList"   
                    ></Multiselect>
                  </b-field>
                </div>
              </div>
              <div class="columns" >
                <div class="column">
                  <b-field label="ລາຍລະອຽດ">
                    <b-input maxlength="1000" rows="10" v-model.trim="selectedBusinessDescription"  type="textarea" placeholder="ລາຍລະອຽດ"></b-input>

                  </b-field>
                </div>
                
              </div>

              <div class="columns" >
                <div class="column">
                  <b-field label="ເບີໂທຕິດຕໍ່">
                    <b-input
                      v-model.trim="selectedPhoneNo"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="" style="margin-top: 30px;">
                    <b-button  
                        class="btn-group-margin is-fullwidth"
                        type="is-success"  
                        @click="saveBusinessInfo"
                        >  <span > ບັນທຶກ</span>
                    </b-button>
                  </b-field>
                </div>
              </div>
             
              
              
              
            </div>
              
          
              
          </div>

        </b-tab-item>    
        
      </b-tabs>
      

      
    </div>


    

    

    
    
    
  </section>
</template>

<script>
import RestAPI from "../../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect },

  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 0,

      selectedBusinessType: null,
      businessTypeList: [
        { ID: "1", NAME: "ຜູ້ຜະລິດ" },
        { ID: "2", NAME: "ຜູ້ຊື້" },
        { ID: "3", NAME: "ຜູ້ສະໜອງ" },
        { ID: "4", NAME: "ສະຖາບັນການເງິນ" },
      ],

      participateList: [],
      bussinessgroup1: [],
      bussinessgroup2: [],
      bussinessgroup3: [],
      bussinessgroup4: [],
      
      // b0: [],

      // b1: [
      //    { TYPEID: "1",EVENTTYPE: "1",ID: "15", BUSINESSTYPE: "ຜູ້ຜະລິດ", BUSINESSDESCRIPTION: "ວນໝາກຫຸ່ງ ພ້ອມສະໜອງໝາກຫຸ່ງຕະຫຼາດທັງປີ",FULLNAME: "ທ່ານ ສົມຮັກ ສົມສີ", AGE: "36", GENDER:"ຊາຍ", SECTION: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ", PHONENO: "2055558888" ,STATUS: "0",  INTERESTEDNUMBER: "0", INTERESTEDLIST: []}
      
      // ],

      // b2: [
      //   { TYPEID: "1",EVENTTYPE: "1",ID: "11", BUSINESSTYPE: "ຜູ້ຊື້", BUSINESSDESCRIPTION: "ສົນໃຈຊື້ໝາກອາໂວກາໂດ ເຂດພາກເໜືອ ຈຳນວນຫຼາຍ",  FULLNAME: "ທ່ານ ບຸນຄອງ ທານະວັນ", AGE: "36", GENDER:"ຊາຍ", SECTION: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ", PHONENO: "2055558888" ,  STATUS: "3", INTERESTEDNUMBER: "3", INTERESTEDLIST: [{ID: "1", NAME:"ທ້າວ ສົມໃຈ ສີແພງວັນ", PHONENO : "2022224444"}, {ID: "2", NAME:"ທ້າວ ດວງພະຈັນ ຈັນທອງ", PHONENO : "2022223333"},{ID: "3", NAME:"ທ້າວ ແສງແກ້ວ ສີປັນຍາ", PHONENO : "2055552222"}]},
      //   { TYPEID: "1",EVENTTYPE: "1",ID: "12", BUSINESSTYPE: "ຜູ້ຊື້", BUSINESSDESCRIPTION: "ສົນໃຈຮັບຊໍື້ ປານິນກະຊັງ ຈຳນວນຫຼາຍ",FULLNAME: "ທ່ານ ດວງຈັນ ສີພາວັນ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງອຸດສາຫະກຳ ແລະ ການຄ້າ", PHONENO: "2055555555", STATUS: "2" , INTERESTEDNUMBER: "2", INTERESTEDLIST: [{ID: "1", NAME:"ທ້າວ ສົມໃຈ ສີແພງວັນ", PHONENO : "2022224444"}, {ID: "2", NAME:"ທ້າວ ຄຳຫຼ້າ ຄຳແພງມີ", PHONENO : "2022223333"}]},
   
      // ],

      // b3: [
      //    { TYPEID: "1",EVENTTYPE: "1",ID: "13", BUSINESSTYPE: "ຜູ້ສະໜອງ", BUSINESSDESCRIPTION: "ມີແນວພັນ ແລະ ອຸປະກອນການສະເສດ ຈຳນວຫຼາຍ",FULLNAME: "ທ່ານ ຄຳຫຼ້າ ແສງມະໂນທອງ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງກະສິກຳ", PHONENO: "2055556666" , STATUS: "2" , INTERESTEDNUMBER: "2", INTERESTEDLIST: [{ID: "1", NAME:"ທ້າວ ສົມໃຈ ສີແພງວັນ", PHONENO : "2022224444"}, {ID: "2", NAME:"ທ້າວ ສີທອງ ຈັນດາລາ", PHONENO : "2022223333"}]},
      //   ],

      // b4: [
      //   { TYPEID: "1",EVENTTYPE: "1",ID: "14", BUSINESSTYPE: "ສະຖາບັນການເງິນ", BUSINESSDESCRIPTION: "ປ່ອຍເງິນກູ້ ດອກເບ້ຍຕ່ຳ ໃຫ້ກັບຊາວກະສິກອນ ເຂດພາກກາງ",FULLNAME: "ທ່ານ ເຂັມທອງ ທຳມະຈັກ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງສຶກສາ", PHONENO: "2055557777" ,STATUS: "1",  INTERESTEDNUMBER: "1", INTERESTEDLIST: [{ID: "1", NAME:"ທ້າວ ສົມໃຈ ສີແພງວັນ", PHONENO : "2022224444"}]},
      // ],

      filteredParticipateList: [],

      
      
      selectedFullName: null,
      selectedAge: null,
      selectedGender: null,
      genderList: [],
      selectedPhoneNo: null,
      selectedBusinessGroup: null,
      businessGroupList: [],

      participateFullname: null,
      participateAge: null,
      participateGender: null,
      participatePhoneNo: null,
      participateStatus: null,

      qrData: null,

      selectedEventtype: 0,

      selectedBusinessDescription: null,

      selectedInterestedList: null,

      selectedBusinesstype: null,
      selectedBusinessRegisterID: null,


      searchByDescription: null,

      loadingData: null,
      
    };
     
    
  },
  methods: {     


    saveBusinessInfo(){

      if(  !this.selectedFullName || this.selectedFullName === null || 
            !this.selectedAge || this.selectedAge === null ||  
            !this.selectedGender || this.selectedGender === null || 
            !this.selectedBusinessGroup || this.selectedBusinessGroup === null ||
            !this.selectedPhoneNo || this.selectedPhoneNo=== null )     {
              this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");
              return false;
      }

      this.selectedBusinesstype = this.selectedBusinessGroup.ID;

      this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
        if (result.value) {

          var params = {
                fullname: this.selectedFullName,
                age: this.selectedAge,
                gender: this.selectedGender.ID,
                businessgroup: this.selectedBusinessGroup.ID,
                phoneno: this.selectedPhoneNo,
                description: this.selectedBusinessDescription,
                username: this.selectedPhoneNo,  
              };

            // console.log("params: " + JSON.stringify(params))
            
            RestAPI.saveBusinessInfo_public(params) 
              .then((res) => {

                  if(res.data.responseData.data=== 'Duplicate phoneno'){
                    this.$swal("ເບີໂທລະສັບ ໄດ້ຖືກນຳໃຊ້ແລ້ວ, ກະລຸນາກວດຄືນ", "", "warning");
                    return;
                  }

                  if(res.data.responseData.data=== 'Duplicate record'){
                    this.$swal("ລາຍການຊ້ຳ, ກະລຸນາກວດຄືນ", "", "warning");
                    return;
                  }


                  this.$swal({
                    title: "ສຳເລັດ",
                    text: "ລົງທະບຽນ ສຳເລັດ!",
                    icon: "success",
                    timer: 500,
                    showConfirmButton: false, 
                  });

                  this.selectedFullName = null;
                  this.selectedAge = null;
                  this.selectedGender = null;
                  this.selectedPhoneNo = null;
                  this.selectedBusinessGroup = null;
                  this.selectedBusinessDescription= null;

                  // this.selectBusinessType(selectedBusinesstype);
                  this.getBusinessType(1);
                  
                  this.activeTab = 1;

                  

              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
            });
        }
      });

      },

    // selectBusinessType(businesstype){
    //   this.selectedBusinesstype = businesstype;
    //   var params = {
    //             businesstype: businesstype,
    //             username: this.username,  
    //       };

    //   RestAPI.getBusinessDataFromType(params)
    //     .then((res) => {
    //       if( res.data.responseData.data.length > 0){
    //         this.participateList = res.data.responseData.data;
    //         this.filteredParticipateList = res.data.responseData.data;  
    //       }

    //       this.activeTab = 1; 
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
      

    // },

    selectBusinessType(businesstype, data){
      this.selectedBusinesstype = businesstype;
      this.participateList =data;
      this.filteredParticipateList = data; 
      this.activeTab = 1;
    },

    getBusinessType(isAfterRegister = null){
      // console.log("loading ...")
      var params = {
                username: 'public',  
          };
      
      // console.log("getBusinessType_public")

      RestAPI.getBusinessType_public(params)
        .then((res) => {
            this.bussinessgroup1 = res.data.responseData.data.group1;
            this.bussinessgroup2 = res.data.responseData.data.group2;
            this.bussinessgroup3 = res.data.responseData.data.group3;
            this.bussinessgroup4 = res.data.responseData.data.group4;  
           
            if(isAfterRegister ==2){  
              console.log("reload ...")
            }else if(isAfterRegister==1){
              this.activeTab = 0; 
            }

            if(isAfterRegister==1){
              
              if(this.selectedBusinesstype == 1){
                this.participateList = this.bussinessgroup1;
                this.filteredParticipateList  = this.bussinessgroup1;
              }else if(this.selectedBusinesstype == 2){
                this.participateList = this.bussinessgroup2;
                this.filteredParticipateList  = this.bussinessgroup2;
              }else if(this.selectedBusinesstype == 3){
                this.participateList = this.bussinessgroup3;
                this.filteredParticipateList  = this.bussinessgroup3;
              }else if(this.selectedBusinesstype == 4){
                this.participateList = this.bussinessgroup4;
                this.filteredParticipateList  = this.bussinessgroup4;
              }

              this.selectBusinessType(this.selectedBusinesstype, this.filteredParticipateList);
            }
              

        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
      

    },

    interestedIn(ID){

      this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
        if (result.value) {

          var params = {
                 businessregisterid: ID,
                fullname: this.selectedFullName,
                phoneno: this.selectedPhoneNo,
                description: this.selectedBusinessDescription,
                username: this.selectedPhoneNo,  
              };


          // console.log("params: " +JSON.stringify(params))

            
            RestAPI.interestedIn_public(params) 
              .then((res) => {
                
                if(res.data.responseData.data==="ok"){
                    this.$swal({
                      title: "ສຳເລັດ",
                      text: "ດຳເນີນການ ສຳເລັດ!",
                      icon: "success",
                      showConfirmButton: true, 
                    });

                  this.activeTab = 0
                }else{
                  this.$swal({
                      title: "ຜິດພາດ",
                      text: "ຜິດພາດ",
                      icon: "error",
                    });
                }

                this.selectedFullName = null;
                this.selectedPhoneNo = null;
                this.selectedBusinessDescription = null;

              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
            });
        }
      });

        
    },

    paymentConfirm(){
      this.$swal({
        title: "ສຳເລັດ",
        text: "ດຳເນີນການ ສຳເລັດ!",
        icon: "success",
        showConfirmButton: true, 
      });
    },

    openParticipateForm(){
      this.activeTab = 1;
    },

    // loadData(){
    //   this.filteredParticipateList = this.participateList;

    // },

    searchData(){
        this.filteredParticipateList = this.participateList.filter(data => {
          return data.DESCRIPTION.toLowerCase().includes(this.searchByDescription.toLowerCase());
        });


      

      
    },
    
    getParticipateDetail(data){
      this.activeTab = 2; 
      this.participateFullname = data.FULLNAME;
      this.participateAge = data.AGE;
      this.participateGender = data.GENDER;
      this.participateSection = data.SECTION;
      this.participatePhoneNo = data.PHONENO;
      this.participateStatus=  data.STATUS;
      this.selectedBusinessDescription = data.BUSINESSDESCRIPTION;
      this.selectedBusinessType = data.BUSINESSTYPE;
      this.selectedInterestedList = data.INTERESTEDLIST;

      this.qrData = data.ID + " | " + data.FULLNAME + " | " + data.SECTION;
    },

    getBusinessGroup() {
      RestAPI.getBusinessGroup()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.businessGroupList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
   
    getGender() {
      RestAPI.getGender()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.genderList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
   

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    loadData () {
        this.loadingData = setInterval(() => {
          this.getBusinessType(2);
          
   
        }, 10000)
    },
    

    

  },
  created () {
      this.loadData()
  },
  mounted() {
    // this.roleid = this.user ? this.user.ROLEID : null;
    this.roleid = 3;
    // this.username = this.user.USERNAME;   

    this.currentDate = new Date();
    // this.loadData();
    this.getBusinessGroup();
    this.getGender();
    this.getBusinessType();



    
    

  
  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    qrCodeUrl() {
      // Use the qrserver API to generate the QR code image URL
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(this.qrData)}`;
    },
   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.card-container {
    margin: 0px;
  }

  .card-item {
    padding: 5px; /* Smaller spacing between cards */
  }

  .card {
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 6px; /* Slightly reduced border radius for compact look */
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow for clean look */
    padding: 1px; /* 1px padding inside the card for a tight design */
    text-align: center;
    width: 100%;
    transition: transform 0.2s, box-shadow 0.2s;
  }

  .card2 {
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 6px; /* Slightly reduced border radius for compact look */
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow for clean look */
    padding: 1px; /* 1px padding inside the card for a tight design */
    width: 100%;
    transition: transform 0.2s, box-shadow 0.2s;
  }

  .card:hover {
    transform: translateY(-3px);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
  }

  .card-content {
    font-size: 1em; /* Reduced font size */
    font-weight: bold;
    color: #333;
    padding: 10px 1px 10px 1px;
  }

  .card-content2 {
    font-size: 1em; /* Reduced font size */
    color: #333;
    padding: 10px 1px 10px 1px;
  }

  /* Ensure Two Columns Per Row for All Screen Sizes */
  .columns {
    display: flex;
    flex-wrap: wrap;
  }

  .card-item {
    flex: 1 1 50%; /* Each item takes 50% width */
  }

/* .status-3 {
  background-color: #4FC3F7; 
  color: white;
}

.status-2 {
  background-color: #B3E5FC; 
  color: black;
}

.status-0 {
  background-color: #CFD8DC; 
  color: black;
}

.status-default {
  background-color: transparent; 
  color: inherit;
} */

.centered-content {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.card {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;  
  margin-bottom: 0px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.content{
  font-size: 16px;
  margin-left: 5px; 
  margin-right: 5px;
}

.title24{
  font-size: 24px;
  font-weight: bold;
}

.title24-light{
  font-size: 24px;
}

.title20{
  font-size: 20px;
  font-weight: bold;
}

.title20-light{
  font-size: 20px;
}

.title16{
  font-size: 18px;
  font-weight: bold;
}

.title16-light{
  font-size: 18px;
}

.title14{
  font-size: 16px;
  font-weight: bold;
}
.title14-light{
  font-size: 16px;
  font-weight: bold;
}

.title12{
  font-size: 14px;
  font-weight: bold;
}

.title12-light{
  font-size: 14px;
}

.red16bold{
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.red16{
  color: red;
  font-size: 18px;
  
}

.red14bold{
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.red14{
  color: red;
  font-size: 16px;
}

.red12bold{
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.red12{
  color: red;
  font-size: 14px;
}




.container{  
  margin-top: 10px;
}
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-50 {
  flex: 0 0 50%;
}

.column-65 {
  flex: 0 0 65%;
}

.column-35 {
  flex: 0 0 35%;
}

.column-30 {
  flex: 0 0 30%;
}
.column-70 {
  flex: 0 0 70%;
}

.column-20 {
  flex: 0 0 20%;
}
.column-80 {
  flex: 0 0 80%;
}


.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
